import { RouteObject } from "react-router-dom";
import {
  JmixReportsPage,
  JMIX_REPORTS_PATH,
} from "@/modules/jmix-reports/pages/jmix-reports";

export const jmixReportsRoutes: RouteObject[] = [
  {
    path: JMIX_REPORTS_PATH,
    element: <JmixReportsPage />,
  },
];
